import { Component, Input, OnInit, DoCheck } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";

import ActionTypesEnum from '@shared/enums/action-constant.enum';

import { CustomEventService } from '@shared/services/custom-event.service';
import { GitwiserService } from "@shared/services/gitwiser.service";

import { validateFormGroup, createFormGroup } from "@shared/utils/form.util";

import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Subscription } from "rxjs";


@UntilDestroy()
@Component({
  selector: 'app-initialize-analysis-v2-modal',
  templateUrl: './initialize-analysis-v2-modal.component.html'
})
export class InitializeAnalysisV2ModalComponent implements OnInit, DoCheck {
  @Input() steps: Team.TeamModel[];
  @Input() scopeId: string;

  initialSteps: Team.TeamModel[];
  fields: Widget.Field[];
  exclusion = [];
  scoreCards = [];
  deploymentAnalyticsPatterns = [];
  analysisDateRange = '';
  addAnalysisForm: FormGroup;
  deploymentAnalyticsDatasources: any;
  selectedFields: Map<string, any> = new Map();
  localSelectedFields: Map<string, any> = new Map();
  currentStepIndex = 0;
  currentStep: any;
  stepInnerLoading = false;
  currentStepDisabled: boolean;
  customEventSubscription: Subscription;
  formData: any;
  disabledPlanningDay = false;
  sortedList: any;
  pipeLineStrategy: "SINGLE_PIPELINE"
  oldFields: Map<string, any> = new Map();
  initialField: Widget.Field[];
  previousDeploymentFileds: Widget.Field[];
  loading = false;
  isCooldown = false;
  cooldownDuration = 3000;

  @Input() teams: any;

  compareFn = (o1: any, o2: any) => (o1 && o2 ? o1.key === o2.key : o1 === o2);

  constructor(private customEventService: CustomEventService, private gitwiserService: GitwiserService, private fb: FormBuilder) { }

  ngDoCheck(): void {
    // this.addAnalysisForm = createFormGroup(this.fields);
  }

  setSelectedFieldData = (fields: any[] = []): void => {
    fields.forEach(field => {
      let value = null;

      const selections = field.data.selections;
      if (selections) {
        value =
          selections instanceof Array
            ? selections.map(item => (item?.key ? item.key : item))
            : selections instanceof Object
            ? selections.key
            : selections instanceof String
            ? selections
            : selections;
        this.addAnalysisForm.get(field.key).setValue(value);
        this.selectField(value, field);
      }
    });
  };

  setSelectedIncidentFieldData = (fields: any[] = []): void => {
    fields.forEach(field => {
      let value = null;

      let selections = field?.data?.selections;
      selections =
        selections === undefined
          ? this.selectedFields.get(field.key)
          : selections;
      if (selections) {
        value = selections instanceof Array ? selections.map(item => item) : selections instanceof Object ? selections.key : selections instanceof String ? selections : selections;
        this.addAnalysisForm.get(field.key).setValue(value);
      }
      this.customEventService.announceEvent(
        ActionTypesEnum.ANALYSIS_CREATE_FIELD_SELECTED,
        {
          field,
          form: this.addAnalysisForm,
          value
        }
      );
    });
  };

  setSelectedDepymentFieldData = (fields: any[] = []): void => {
    fields.forEach(field => {
      let value = null;
      let selections = field?.data?.selections;
      selections =
        selections === undefined
          ? this.selectedFields.get(field.key)
          : selections;
      if (selections) {
        value = selections instanceof Array ? selections.map(item => item) : selections instanceof Object ? selections.key : selections instanceof String ? selections : selections;
        this.addAnalysisForm.get(field.key).setValue(value);
      }
      this.customEventService.announceEvent(ActionTypesEnum.ANALYSIS_CREATE_FIELD_SELECTED, { field, form: this.addAnalysisForm, value });
    });
  };

  ngOnInit(): void {
    this.initialSteps = this.steps;
    this.addAnalysisForm = createFormGroup(this.fields);
    this.customEventService.eventAnnounced$
      .pipe(untilDestroyed(this)).subscribe(
        ({ action, data }) => {
          if (action === ActionTypesEnum.WIDGET_CREATE_ONE_ITEM_SELECTED) {
            this.selectField(data.event, data.field);
          }
        });
  }

  isStepDisabled(index: number): boolean {
    return index > this.currentStepIndex;
  }

  changeCurrentStep($event: 'increase' | 'decrease' | 'not-change' | number) {
    this.stepInnerLoading = true;
    const hasEmptyControls =
      Object.keys(this.addAnalysisForm.controls).length === 0;
    if (
      ($event === 'increase' ||
        (typeof $event === 'number' && $event > this.currentStepIndex)) &&
      !(
        (this.currentStepIndex === 0 && $event === 1) ||
        (this.currentStepIndex === 1 && $event === 0)
      )
    ) {
      validateFormGroup(this.addAnalysisForm);
      // check for empty, except for step 0
      if (this.currentStepIndex !== 0 && (hasEmptyControls || this.addAnalysisForm.invalid || !this.isStepValid())) {
        this.stepInnerLoading = false;
        return;
      }
    }

    switch ($event) {
      case 'increase': {
        this.fields?.forEach(f => {
          this.oldFields.set(f.key, f);
        });
        this.currentStepIndex = ++this.currentStepIndex;
        break;

      }
      case 'decrease': {
        this.customEventSubscription?.unsubscribe();
        this.currentStepIndex = --this.currentStepIndex;
        break;
      }
      case 'not-change': {
        break;
      }
      default:
        if (typeof $event === 'number') {
          this.currentStepIndex = $event;
        }
        break;
    }
    this.currentStep = this.currentStepIndex !== 0 && this.steps[this.currentStepIndex - 1];
    if (!this.currentStep) {
      return;
    }

    this.stepInnerLoading = false;
    if (this.currentStepIndex !== 0) {
      this.nextStepFields()
    }
  }

  nextIncidentSourceTemplates(value: string) {
    this.fields = this.initialField;
    const apmField = this.fields[0]
    const parentOldvalue = this.selectedFields.get(apmField.key) === undefined ? null : this.selectedFields.get(apmField.key)
    apmField.data.selections = apmField.multiSelect ? [parentOldvalue] : parentOldvalue;
    this.gitwiserService.deploymentAnalyticsApmFields(value).subscribe(response => {
      this.fields = this.fields.concat(response.fields);
      response.fields.forEach(item => {
        const oldvalue = this.selectedFields.get(item.key) === undefined ? null : this.selectedFields.get(item.key);
        const oldfield = this.oldFields.get(item.key);

        if (oldvalue) {
          item.data = oldfield ? oldfield.data : item.data;
          item.backStep = true;
          item.data.selections = oldvalue
        }

        item.required = item.validators?.find(p => p === 'required');
      });
      this.addAnalysisForm = createFormGroup(this.fields)
      this.setSelectedIncidentFieldData(this.fields)
    })
  }

  nextDeploymentAnalyticsFields(value: any, isChangeAddon: boolean) {
    if (isChangeAddon) {
      this.previousDeploymentFileds?.forEach(d => {
        this.oldFields.delete(d.key)
        this.selectedFields.delete(d.key)
        this.localSelectedFields.delete(d.key)
      })
    }

    this.fields = this.initialField;
    this.fields[0].data.selections = this.selectedFields.get(this.fields[0].key)
    this.gitwiserService.deploymentAnalyticsFields(value,true).subscribe(response => {
      this.fields = this.fields.concat(response.fields);
      this.previousDeploymentFileds = response.fields
      response.fields.forEach(item => {
        const oldvalue = this.selectedFields.get(item.key) === undefined ? null : this.selectedFields.get(item.key);
        const oldfield = this.oldFields.get(item.key);
        if (oldvalue) {
          item.data = oldfield ? oldfield.data : item.data;
          item.backStep = true;
          item.data.selections = oldvalue;
        }

        item.required = item.validators?.find(p => p === 'required');
      })
      this.addAnalysisForm = createFormGroup(this.fields)
      this.setSelectedDepymentFieldData(this.fields)
    });
  }

  nextStepFields() {
    const isIncludeDeployment = this.selectedFields.get("deploymentAnalyticsSelectedReleaseStrategy") !== undefined && this.selectedFields.get("deploymentAnalyticsSelectedReleaseStrategy") !== 'NONE_PIPELINE' ? true : false
    this.gitwiserService.getFieldUrl(this.currentStep.fieldUrl, isIncludeDeployment).
      pipe(untilDestroyed(this)).subscribe(res => {
        this.fields = res.fields;
        this.fields.forEach(field => {
          if(field.key === 'scoreCards') {
            if (this.teams && this.teams.length > 0) {
              field.data.content  = this.teams.filter(item => item.scorecardId !== null && item.scorecardId !== undefined).map(team => ({
                key: team.scorecardId,
                label: team.name,
                selected: false
              }));
            }
          }
          if (field.key === "pullRequestAnalytics") {
            const prOldvalue = this.selectedFields.get(field.key)
            if (prOldvalue !== undefined) {
              this.checkboxChange(field, prOldvalue)
              field.data.selections = prOldvalue;
            } else {
              this.checkboxChange(field, true)
            }
          }

          const oldfield = this.oldFields.get(field.key);
          const oldvalue = this.selectedFields.get(field.key)
          if (oldvalue) {
            field.data = oldfield ? oldfield.data : field.data;
            field.backStep = true;
            field.data.selections = oldvalue;
          }

          field.required = field.validators?.find(item => item === 'required');
          const regex = field.validators?.find(item => item.startsWith('regex::'));
          if (regex) {
            field.regex = regex.substring(7, regex.length);
          }



          // if (field.data?.content?.length === 1) {
          //  const selection = { key: field.data.content[0].key };
          // field.data.selections = field.multiSelect ? [selection] : selection;
          // }
        });
        this.initialField = this.fields;
        this.addAnalysisForm = createFormGroup(this.fields)
        this.setSelectedFieldData(this.fields)
      });
  }


  clearIncidentSource() {
    this.selectedFields.delete("deploymentAnalyticsIncidentSource")
    this.selectedFields.delete("deploymentAnalyticsIncidentSourceDatasource")
    this.selectedFields.delete("deploymentAnalyticsIncidentApplication")

    this.localSelectedFields.delete("deploymentAnalyticsIncidentSource")
    this.localSelectedFields.delete("deploymentAnalyticsIncidentSourceDatasource")
    this.localSelectedFields.delete("deploymentAnalyticsIncidentApplication")

    this.nextStepFields()
  }

  searchSelect(value: string, field: any) {
    if (!field?.data?.contentAll || !field?.data?.defaultContent) {
      return;
    }

    if (field?.data?.contentAll) {
      field.data.contentAll = [...field?.data?.contentAll].sort((a, b) =>
        a.label.localeCompare(b.label)
      );
    }

    field.data.content = field.data.defaultContent || field.data.contentAll.slice(0,500);

    if (value.length > 2) {
      const searchValue = value?.toLocaleLowerCase() || '';
      const sources =
        field?.data?.contentAll ||
        (field.data.contentAll.defaultContent
          ? field.data.defaultContent
          : field.data.content);

      field.data.content = sources
        .filter(item => item.label.toLowerCase().includes(searchValue))
        .sort((a, b) => {
        const aLabel = a.label.toLowerCase();
        const bLabel = b.label.toLowerCase();

        // Birebir eşleşen varsa en üste çıkar
          if (aLabel === searchValue) {
          return -1;
        }
          if (bLabel === searchValue) {
          return 1;
        }

        // Geri kalan alfabetik sıralansın
        return aLabel.localeCompare(bLabel);
      })
        .slice(0, 500);

      if (field?.widgetFieldListener && field.widgetFieldListener.eventType === 'KEYUP') {
        this.customEventService.announceEvent(
          ActionTypesEnum.ANALYSIS_CREATE_FIELD_KEYUP_ACTION,
          { field, form: this.addAnalysisForm, value }
        );
      }
    }

    field.loading = false;

      return;
    //
    // if (!field?.data?.contentAll || !field?.widgetFieldListener || !field?.data?.defaultContent) {
    //   return;
    // }
    //
    //
    //
    // if (value.length > 2) {
    //   const searchValue = value?.toLocaleLowerCase() || '';
    //   let foundValue: any[] | null = null;
    //
    //
    //
    //
    //   if (searchValue.length > 0) {
    //     const sources= field.data.contentAll.length ? field.data.contentAll
    //       : field.data.contentAll.defaultContent ? field.data.defaultContent : field.data.content;
    //     if (sources.length > 0) {
    //       foundValue = sources
    //         .filter(item => item.label?.toLocaleLowerCase().includes(searchValue))
    //         .slice(0, 500);
    //     }
    //   }
    //   if (foundValue?.length > 0) {
    //     field.data.content = foundValue;
    //     return;
    //   }
    //   if (field.widgetFieldListener.eventType === 'KEYUP') {
    //     this.customEventService.announceEvent(
    //       ActionTypesEnum.ANALYSIS_CREATE_FIELD_KEYUP_ACTION,
    //       { field, form: this.addAnalysisForm, value });
    //   }
    // } else {
    //   field.data.content = field.data.defaultContent;
    //   return;
    // }
    // field.loading = false;
  }

  changeStep(type: string): void {
    if (this.isCooldown) {
      return;
    }

    switch (type) {
      case 'next': {
        this.startCooldown();
        this.changeCurrentStep('increase');
        break;
      }
      case 'previous': {
        this.changeCurrentStep('decrease');
        break;
      }
      case 'create': {
        validateFormGroup(this.addAnalysisForm);
        if (this.addAnalysisForm.invalid) {
          return;
        }
        this.createAnalysis()
        break;
      }
    }
  }

  startCooldown(): void {
    this.isCooldown = true;
    setTimeout(() => {
      this.isCooldown = false;
    }, this.cooldownDuration);
  }

  createAnalysis() {
    this.loading = true
    const isIncludeDeployment = this.selectedFields.get("deploymentAnalyticsSelectedReleaseStrategy") !== undefined && this.selectedFields.get("deploymentAnalyticsSelectedReleaseStrategy") !== 'NONE_PIPELINE' ? true : false

    const requestData: any = {};
   // requestData["pullRequestAnalytics"] = { "key": true, "label": true }
    requestData["cloneWithSSH"] = { "key": false, "label": false }

    if(isIncludeDeployment){
      requestData["deploymentAnalytics"] = { "key": true, "label": true }
    }

    const withoutFormData = ["scoreCards", "exclusionPatterns", "deploymentAnalyticsPatterns", "analysisDateRange"];

    withoutFormData.forEach(keys => {
      const value = this.localSelectedFields.get(keys);
      if (value !== null || value !== undefined) {
        requestData[keys] = value
      }
      this.localSelectedFields.delete(keys)

    })
    const formData: any = {};

    if(isIncludeDeployment){
      formData["deploymentAnalytics"] = { "key": true, "label": true }
    }

    this.localSelectedFields.forEach((values, keys) => {
      if (keys !== undefined && values !== null && values !== undefined) {
        if (keys === "deploymentAnalyticsJobName" && values?.key===undefined) {
          formData[keys] = { "key": values, "label": values }
        } else if (keys === "deploymentAnalyticsReleasePattern") {
          formData[keys] = { "key": values, "label": values }
        } else if (keys === "deploymentParameterValue") {
          formData[keys] = { "key": values, "label": values }
        } else if (keys === "deploymentCommitVariableKey") {
          formData[keys] = { "key": values, "label": values }
        } else if (keys === "deploymentCommitVariableKey") {
          formData[keys] = { "key": values, "label": values }
        } else if (keys === "deploymentCloneURLVariableKey") {
          formData[keys] = { "key": values, "label": values }
        } else {
          formData[keys] = values
        }
      }
    })


    formData["pullRequestAnalytics"] = { "key": this.localSelectedFields.get("pullRequestAnalytics"), "label": this.localSelectedFields.get("pullRequestAnalytics") }
    requestData["formData"] = formData
    // Exception case analysisDateRange should be enum
    requestData["analysisDateRange"] = formData["analysisDateRange"]?.key


    this.gitwiserService.create(requestData, this.scopeId).pipe(
      untilDestroyed(this)
    ).subscribe((response) => {
      this.cancelForm();
      this.customEventService.announceEvent(ActionTypesEnum.LOAD_INITIAL_ANALYSIS);
    }, error => {
      console.log('connection error', error);
    }).add(() => {
      this.loading = false

    });;
  }

  checkboxChange(value, field) {
    this.selectedFields.set(field.key, value);
    this.localSelectedFields.set(field.key, value)
  }


  selectField(value, field): void {
    if (value === null && "deploymentAnalyticsIncidentSource" === field.key) {
      this.clearIncidentSource();
    }

    value = value instanceof Array ? value.filter(item => item !== undefined) : value;
    const oldValue = this.selectedFields.get("deploymentAnalyticsAddons");
    const isChange = oldValue !== undefined && oldValue !== value



    const selectedValue = field?.data?.contentAll?.find(f => f.key === value);
    if (selectedValue) {
      this.localSelectedFields.set(field.key, selectedValue)
    } else {
      this.localSelectedFields.set(field.key, value)
    }
    this.selectedFields.set(field.key, value);

    if ("deploymentAnalyticsAddons" === field.key) {
      this.nextDeploymentAnalyticsFields(value, isChange);
      return;
    }
    if ("deploymentAnalyticsIncidentSource" === field.key) {
      this.nextIncidentSourceTemplates(value);
      return;
    }
    this.customEventService.announceEvent(ActionTypesEnum.ANALYSIS_CREATE_FIELD_SELECTED, { field, form: this.addAnalysisForm, value });
  }

  handlePipeLineStrategy(value, field): void {
    this.steps = this.initialSteps;
    if ("NONE_PIPELINE" === value) {
      this.steps = this.steps.filter(f => "CD_CI_ANALYSIS" !== f.name && "CI_ANALYSIS" !== f.name && "CD_ANALYSIS" !== f.name && "INCIDENT_SOURCE" !== f.name);
    } else if ("SINGLE_PIPELINE" === value) {
      this.steps = this.steps.filter(f => "CI_ANALYSIS" !== f.name && "CD_ANALYSIS" !== f.name);

    }
    this.selectField(value, field)
  }




  isStepValid(): boolean {
    return true;
  }


  resetForm(): void {
    this.addAnalysisForm.reset();
  }

  cancelForm(): void {
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
  }

}
